var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.messages.length > 0 || _vm.errors.length > 0)?_c('div',{class:{
  'flash-success-message': _vm.messages.length > 0 && !_vm.inSnackbar,
  'flash-error-message': _vm.errors.length > 0 && !_vm.inSnackbar,
  'flash-success-message-in-snackbar': _vm.messages.length > 0 && _vm.inSnackbar,
  'flash-error-message-in-snackbar': _vm.errors.length > 0 && _vm.inSnackbar
}},[_vm._l((_vm.messages),function(message,index){return _c('strong',{key:'flash-success-' + index,domProps:{"innerHTML":_vm._s(message)}},[_c('br')])}),_vm._l((_vm.errors),function(error,index){return _c('strong',{key:'flash-error-' + index,domProps:{"innerHTML":_vm._s(error)}},[_c('br')])}),_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }